import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const HomeIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="m8.00001 4.12671 3.33329 3v5.20669H10V8.33337H6.00001v4.00003H4.66668V7.12671l3.33333-3Zm0-1.79334-6.66667 6h2v5.33333h4V9.66671h1.33334v3.99999h4.00002V8.33337h2l-6.66669-6Z" />
  </Icon>
);

export default memo(HomeIcon);
